import React from 'react'
import {Tooltip} from '../BaseComponents'
import {textOfChildren} from '../textTruncation'
import {EllipsisText} from './Table'

export interface CardTextLineProps {
  children: React.ReactNode
  text?: string
}

/**
 * One line of order card text. It never wraps, ends in "…" when it doesn't fit, and
 * only then shows the whole text in the DS truncation tooltip: on hover and focus, and on a touch
 * or pen tap (`Tooltip tapToReveal`), which then stays with the text instead of opening the card.
 * Put it in a box that owns the line's geometry (`min-width: 0; overflow: hidden`).
 */
export const CardTextLine: React.FC<CardTextLineProps> = ({children, text}) => (
  <Tooltip content={text ?? textOfChildren(children)} block tapToReveal>
    <EllipsisText>{children}</EllipsisText>
  </Tooltip>
)

CardTextLine.displayName = 'CardTextLine'
